import { EntregaZERealizada, EntregaZERealizadaDTO, FiltroEntregaZE } from "./entregazerealizada";
import { GuiaDTO } from "./guia";

export interface LiberacionEntregaZE {

    IdRegistro: number;

    /**Usuario que hizó la liberación */
    IdUsuario: number;

    /**Fecha de liberación */
    FechaLiberacion: Date | string;

    /**Entregas que fueron liberadas por medio de esta liberación */
    EntregasLiberadas: EntregaZERealizada[];

}

export interface LiberacionEntregaZEDTO extends LiberacionEntregaZE {
    NombreUsuario: string;
    NombreChoferZE: string;
    NombreSucursal: string;
    NombreProveedor: string;
    CantidadAcuses: number;
    CantGuias: number;
    TotalFXC: number;
    EntregasLiberadas: EntregaZERealizadaDTO[];
    Guias: GuiaDTO[];
}

export interface LiberacionEntregaZEModel {
    IdEntregas: number[];
    Filtro: Partial<FiltroEntregaZE>;
    Tab: number;
}

export const liberacionEntregaZEModelInicial: LiberacionEntregaZEModel = {
    IdEntregas: [],
    Filtro: {},
    Tab: 0
}


// WEBPACK FOOTER //
// ./app/models/liberacionentregaze.ts